import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouletteQuickDetails } from 'app/core/model/roulette-quick-details.model';
import { WebRouletteStatus } from 'app/core/model/web-roulette-status';
import { Language } from 'app/shared/model/enums';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Roulette } from '../model/roulette.model';
import { SaveRouletteRequest } from '../model/save-roulette-request.model';

@Injectable({
  providedIn: 'root'
})
export class WebRouletteService {



  constructor(private httpClient: HttpClient) {

  }
  getDefaultRoulette(language): Observable<Roulette> {
    return this.httpClient.post<Roulette>(`/webroulette/default`, { language });
  }
  getRoulettesList() {
    return this.httpClient.get(`/webroulette`);
  }
  getRoulette(rouletteId: number): Observable<Roulette> {
    return this.httpClient.get<Roulette>(`/webroulette/${rouletteId}`).pipe(map(roulette => {
      if(roulette==null)
      return null;
      roulette.GeneralDetails.StartDate = roulette.GeneralDetails.StartDate ? new Date(roulette.GeneralDetails.StartDate) : null;
      roulette.GeneralDetails.EndDate = roulette.GeneralDetails.EndDate ? new Date(roulette.GeneralDetails.EndDate) : null;
      return roulette;
     
    }));
  }
  saveNewRoulette(roulette: SaveRouletteRequest): Observable<number> {
    return this.httpClient.post<any>('/webroulette', roulette).pipe(map((res: { NewEntityId: number }) => res.NewEntityId));
  }
  saveRoulette(id: number, roulette: SaveRouletteRequest) {
    return this.httpClient.put(`/webroulette/${id}`, roulette);
  }
  getSpinnersCategories(language: Language): Observable<{ Id: number, Description: string }[]> {
    return this.httpClient.post<any>('/spinners/getSpinnersCategories', { language }).pipe(map(res => res.SpinnerTypes as { Id: number, Description: string }[]));
  }
  getSpinnersByCategory(spinnerTypeId: number,lastLanguage:Language) {
    return this.httpClient.get<any>(`/spinners/getSpinnersByCategory/${spinnerTypeId}/${lastLanguage}`).pipe(map(r => r.Spinners));
  }
  getCouponsIcons(): Observable<{ Id: number, Url: string }[]> {
    return this.httpClient.get<any>('/coupon/icons').pipe(map(res => {
      return res.Icons as { Id: number, Url: string }[];
    }));
  }
  getMyRoulettes(): Observable<RouletteQuickDetails[]> {
    return this.httpClient.get<any>('/webroulette/my-roulettes').pipe(map(res => {
      return res.Roulettes as RouletteQuickDetails[];
    }));
  }
  deleteRoulette(id: number) {
    return this.httpClient.delete(`/webroulette/${id}`);
  }

  getLids(request: any): Observable<{ Lids: any[], TotalCount: number }> {
    return this.httpClient.post<{ Lids: any[], TotalCount: number }>(`/webroulette/lids`, request).pipe(share());
  }
  getCouponsByLid(lidId: number) {
    return this.httpClient.post(`/webroulette/getCouponsByLid`, {
      lidId
    }).pipe(map((res: any) => res), share());
  }
  getChangePackageText(rouletteStatus: WebRouletteStatus, autoRenewalPackage: boolean): string {
    let descriptionTranslateKey;
    switch (rouletteStatus) {
      case WebRouletteStatus.expired:
      case WebRouletteStatus.notPurched:
        descriptionTranslateKey = 'ROULETTE.ACTIVATE';
        break;
      case WebRouletteStatus.spinsLimit:
        if (autoRenewalPackage) {
          descriptionTranslateKey = 'ROULETTE.UPGRADE';
        } else {
          descriptionTranslateKey = 'ROULETTE.ACTIVATE';
        }
        break;
      case WebRouletteStatus.spinsLimitForFreePackage:
        descriptionTranslateKey = 'ROULETTE.ACTIVATE';
        break;
      case WebRouletteStatus.purched:
      case WebRouletteStatus.purchedFreePackage:
        descriptionTranslateKey = 'ROULETTE.UPGRADE';
        break;
    }
    return descriptionTranslateKey;
  }



}
